<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat plátce</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
            <biller-form
                :entity="entity"
                :ownId="ownId"
                :is-editable="true"
                @own-id-change="setOwnId"
                ref="billerformref"
            ></biller-form>
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BillerForm from "@/components/views/billers/BillerForm"
import billers from "@/components/views/billers/mixins/billers"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "BillerNew",
  components: {BillerForm},
  mixins: [detailActions, billers],
  created(BillerService, OperatorService) {
    this.entityService = BillerService
    this.operatorService = OperatorService
    this.getOperatorsAndSetIdOperatorToEntity()
  },
  computed: {
    operatorIdComputed: {
      get() {
        return this.entity.id_operator
      },
      set(newValue) {
        return this.entity.id_operator = newValue
      }
    }
  },
  methods: {
    _processDetailErrorMessage(error) {
      return this.processErrorMessage(error)
    }
  },
  watch: {
    operatorIdComputed: {
      handler(newVal, oldVal) {
        if (Number(oldVal) !== Number(newVal)) {
          this.entity.tag_ids = [];
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/billers/BillerNew.vue